import { all, fork } from "redux-saga/effects";

import DeviceSaga from "./deviceSaga";
import store from './store-saga';
import NotificationSaga from "./notification-saga";
import storeByIdSaga from "./store-by-id-saga";
import table from './table-saga';
import login from './login';
import saLogin from './sa-login';
import payment from './payment';
import receipt from './receipt-saga';

export default function* rootSaga() {
  yield all([
    fork(DeviceSaga),
    fork(store),
    fork(login),
    fork(NotificationSaga),
    fork(storeByIdSaga),
    fork(table),
    fork(saLogin),
    fork(payment),
    fork(receipt),
  ]);
}
